import { request } from "../utils/request.js"

export const dataDict_findVoByCode = (code, args) => request({
    url: 'dataDict/findVoByCode',
    method: 'GET',
    params: { code },
    showFailMessage: true,
    ...args
})

export const dataDict_findByPage = (pojo, args) => request({
    url: 'dataDict/findByPage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const dataDict_findById = (id, args) => request({
    url: 'dataDict/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const dataDict_addNew = (pojo, args) => request({
    url: 'dataDict/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const dataDict_update = (pojo, args) => request({
    url: 'dataDict/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const dataDict_deleteById = (id, args) => request({
    url: 'dataDict/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const dataDict_changeFrozenStatus = (id, args) => request({
    url: 'dataDict/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/dataDict.js